import { render, staticRenderFns } from "./MakePic.vue?vue&type=template&id=81f4eab0&scoped=true&"
import script from "./MakePic.vue?vue&type=script&lang=js&"
export * from "./MakePic.vue?vue&type=script&lang=js&"
import style0 from "./MakePic.vue?vue&type=style&index=0&id=81f4eab0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81f4eab0",
  null
  
)

export default component.exports